import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between mb-3 border-bottom" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Valor total", -1)
const _hoisted_6 = { class: "text-subtitle" }
const _hoisted_7 = { class: "border-bottom mb-3" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Previsão de pagamento", -1)
const _hoisted_10 = { class: "mb-0 text-subtitle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-warning" }, " A data de recebimento do repasse pode variar conforme o banco. ", -1)
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Status", -1)
const _hoisted_14 = {
  key: 0,
  class: "card"
}
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Extrato do repasse", -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_19 = { class: "mb-0 text-paragraph" }
const _hoisted_20 = { class: "mb-0 text-label text-muted" }
const _hoisted_21 = { class: "mb-0 text-label text-muted" }
const _hoisted_22 = {
  key: 1,
  class: "mb-0 text-label text-muted"
}
const _hoisted_23 = { class: "mb-0 text-subtitle" }
const _hoisted_24 = {
  key: 0,
  class: "fa-solid fa-chevron-right"
}
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Banco", -1)
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between mb-3 border-bottom" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Banco", -1)
const _hoisted_30 = { class: "text-subtitle" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-between mb-3 border-bottom" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Agência", -1)
const _hoisted_33 = { class: "text-subtitle" }
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between mb-3 border-bottom" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Tipo de conta", -1)
const _hoisted_36 = { class: "text-subtitle" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, "Conta (últimos dígitos)", -1)
const _hoisted_39 = { class: "text-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingItems)
      ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.item.formatted_value), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.item.formatted_arrival_date), 1)
                ]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", {
                  class: _normalizeClass(["text-subtitle", _ctx.item.status_config?.payout_detail.color])
                }, _toDisplayString(_ctx.item.status_config?.payout_detail.status), 3)
              ])
            ])
          ]),
          (_ctx.item?.transactions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item?.transactions, (elem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["mb-3", {
              'border-bottom': index + 1 < _ctx.item?.transactions.length,
              'cursor-pointer': elem.has_action,
            }]),
                      key: index,
                      onClick: ($event: any) => (_ctx.handleDetail(elem))
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(elem.payout_type), 1),
                          (elem.appointment)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("p", _hoisted_20, _toDisplayString(elem.appointment_user_name), 1),
                                _createElementVNode("p", _hoisted_21, _toDisplayString(elem.appointment_date), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (elem.payout_date)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(elem.payout_date), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_23, [
                          _createTextVNode(_toDisplayString(elem.payout_net) + " ", 1),
                          (elem.has_action)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 10, _hoisted_17))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.item.bank_account?.bank_name), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.item.bank_account?.routing_number), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.item.bank_account?.type_label), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.item.bank_account?.last_digits), 1)
              ])
            ])
          ])
        ], 64))
  ]))
}